export const translations = {
  en: {
    title: 'PokerPlanning',
    joinExample: 'Room Name (e.g., plan-q2)',
    join: 'Join Session',
    displayName: 'Display Name',
    enterName: 'Enter your name',
    votingOpen: 'Voting Open',
    votingClosed: 'Voting Closed',
    revealed: 'Revealed',
    timer: 'Timer',
    reset: 'Reset',
    revealCards: 'Reveal Cards',
    leave: 'Leave',
    closeRoom: 'Close Room',
    rounds: 'Rounds',
    addRound: 'Add',
    activeRound: 'Active Round',
    average: 'Average',
    voted: 'Voted',
    error: 'Error',
    goHome: 'Go Home',
    verifying: 'Verifying room existence...',
    loading: 'Loading...',
    roundLocked: 'Round Locked / Finished',
    coffee: 'Coffee/Beer',
    kick: 'Kick',
    kickMessage: 'You have been kicked from the room.',
    cancel: 'Cancel',
    // Home keys
    subtitle: 'Create a room and start estimating.',
    roomName: 'Room Name',
    roomPlaceholder: 'e.g. Sprint 23 Planning',
    deckType: 'Deck Type',
    createRoom: 'Create Room',
    creating: 'Creating...',
    buyMeACoffee: 'Sponsor this project',
    buyMeACoffeeMessage:
      'If you like the app and feel it helped you, consider sponsoring it on GitHub!',
  },
  es: {
    title: 'PokerPlanning',
    joinExample: 'Nombre de Sala (ej. plan-q2)',
    join: 'Unirse a Sesión',
    displayName: 'Nombre',
    enterName: 'Ingresa tu nombre',
    votingOpen: 'Votación Abierta',
    votingClosed: 'Votación Cerrada',
    revealed: 'Revelado',
    timer: 'Temporizador',
    reset: 'Reiniciar',
    revealCards: 'Revelar Cartas',
    leave: 'Salir',
    closeRoom: 'Cerrar Sala',
    rounds: 'Rondas',
    addRound: 'Agregar',
    activeRound: 'Ronda Activa',
    average: 'Promedio',
    voted: 'Votos',
    error: 'Error',
    goHome: 'Ir al Inicio',
    verifying: 'Verificando existencia de sala...',
    loading: 'Cargando...',
    roundLocked: 'Ronda Bloqueada / Finalizada',
    coffee: 'Café/Cerveza',
    kick: 'Expulsar',
    kickMessage: 'Has sido expulsado de la sala.',
    cancel: 'Cancelar',
    // Home keys
    subtitle: 'Crea una sala y comienza a estimar.',
    roomName: 'Nombre de Sala',
    roomPlaceholder: 'ej. Planificación Sprint 23',
    deckType: 'Tipo de Mazo',
    createRoom: 'Crear Sala',
    creating: 'Creando...',
    buyMeACoffee: 'Patrocina este proyecto',
    buyMeACoffeeMessage:
      'Si te gusta la app y sientes que te ayudó, ¡puedes apoyarla en GitHub Sponsors!',
  },
};
